/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_pct_hub_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Free percentage calculator. Quickly work out what is X% of Y, what percent one number is of another, and reverse percentages — plus increase, decrease, tip and discount tools.`)
};

const es_pct_hub_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calculadora de porcentaje gratis: halla el X% de Y, qué porcentaje representa un número respecto a otro y porcentajes inversos, más aumento, disminución, propina y descuento.`)
};

const de_pct_hub_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kostenloser Prozentrechner. Berechne schnell, wie viel X % von Y sind, welcher Prozentsatz eine Zahl von einer anderen ist, und rechne Prozentsätze um — plus Rechner für Anstieg, Rückgang, Trinkgeld und Rabatt.`)
};

const nl_pct_hub_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gratis percentagecalculator. Bereken snel X% van Y, welk percentage het ene getal van het andere is, en omgekeerde percentages — plus stijging, daling, fooi en korting.`)
};

const fr_pct_hub_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calculateur de pourcentage gratuit. Trouvez X % de Y, quel pourcentage un nombre représente d'un autre, et l'inverse — plus augmentation, diminution, pourboire, réduction.`)
};

const it_pct_hub_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calcolatore di percentuali gratuito: trova il X% di Y, la percentuale tra due numeri e le percentuali inverse, più aumenti, cali, mance e sconti.`)
};

const pt_br2_pct_hub_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calculadora de porcentagem gratuita. Descubra rapidamente quanto é X% de Y, que porcentagem um número representa de outro, e reverta porcentagens — além de ferramentas de aumento, diminuição, gorjeta e desconto.`)
};

const pt_pct_hub_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calculadora de percentagens gratuita. Calcule X% de Y, que percentagem um número é de outro, e percentagens inversas — mais aumento, diminuição, gorjeta e desconto.`)
};

const ja_pct_hub_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`無料のパーセント計算機。YのX%はいくつか、ある数がもう一方の何パーセントか、パーセントの逆算をすぐに計算。増加・減少・チップ・割引ツールも。`)
};

const zh_pct_hub_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`免费百分比计算器。快速计算 Y 的 X% 是多少、一个数是另一个数的百分之几，以及反推百分比 — 还提供增长、减少、小费和折扣工具。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const pct_hub_meta_description = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.pct_hub_meta_description(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("pct_hub_meta_description", locale)
	if (locale === "en") return en_pct_hub_meta_description(inputs)
	if (locale === "es") return es_pct_hub_meta_description(inputs)
	if (locale === "de") return de_pct_hub_meta_description(inputs)
	if (locale === "nl") return nl_pct_hub_meta_description(inputs)
	if (locale === "fr") return fr_pct_hub_meta_description(inputs)
	if (locale === "it") return it_pct_hub_meta_description(inputs)
	if (locale === "pt-BR") return pt_br2_pct_hub_meta_description(inputs)
	if (locale === "pt") return pt_pct_hub_meta_description(inputs)
	if (locale === "ja") return ja_pct_hub_meta_description(inputs)
	return zh_pct_hub_meta_description(inputs)
};